export const NAME = 'app';

export enum PLATFORM {
  WEB = 'web',
  ANDROID = 'android',
  IOS = 'ios',
}

export const IOS_PLATFORM = 'iOS App Store';
